import { lazy } from "react";

export const LazyCommersDashboard = lazy(
  async () => await import("@/pages/commers/commers.dashboard")
);

export const LazyCommersOrders = lazy(async () => await import("@/pages/commers/commers.orders"));
export const LazyCommersStock = lazy(async () => await import("@/pages/commers/commers.stock"));
export const LazyCommersProfit = lazy(async () => await import("@/pages/commers/commers.profit"));
export const LazyCommersTable = lazy(async () => await import("@/pages/commers/commers.table"));
export const LazyCommersRecommendedKeywords = lazy(
  async () => await import("@/pages/commers/recommended-keywords/commers.recommended.keywords")
);
export const LazyDailyKeywordReport = lazy(
  async () => await import("@/pages/commers/recommended-keywords/daily.keyword.report")
);
// export const LazyCommersTest = lazy(async () => await import("@/pages/commers/commers.test"));
